import { Department } from '@commonTypes/department';

export const findDepartmentById = (departmentsList: Department[], currentDepartmentId: number) => {
  try {
    return departmentsList?.find((department: Department) => department.id === currentDepartmentId);
  } catch (e) {
    return null;
  }
};
